import { render } from "./ErrorScreen.vue?vue&type=template&id=1c11b3b0&scoped=true"
import script from "./ErrorScreen.vue?vue&type=script&lang=js"
export * from "./ErrorScreen.vue?vue&type=script&lang=js"

import "./ErrorScreen.vue?vue&type=style&index=0&id=1c11b3b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c11b3b0"]])

export default __exports__